import { useParams } from "react-router-dom";
import React, {useEffect, useState} from 'react';
import Moment from 'moment';
import '../ManagementSheets.scss';
import LoaderMin from 'components/blocks/Loader/LoaderMin';
import useGetEconomicSheets from "@/services/recordSheets/useGetEconomicSheets";

type guid = string;
interface WorkEnvironment {
  workEnvironmentCompanyId: number,
  name: string,
  ccc: string,
  cif: string,
}
interface Management { // management
  name: string,
  date: string,
  company: string
}
interface ITSDPago extends Management{
  id: number | guid,
  exercise: number,
  pay_start_date: Date | string,
  pay_end_date: Date | string,
  amount: number,
  payment_class: string,
  record_id: number,
  work_environment: WorkEnvironment,
  pay_date: Date | string,
  management_type: string
}

const TSDPago:React.FC= () => {
  const params = useParams<{ detailId: string }>();
  const sheetId = params.detailId?.split('__')[1];
  const { getTSDPayment , loadingEconomicSheet, errorEconomicSheet, dataEconomicSheet} = useGetEconomicSheets();
  useEffect(()=> {
    getData();
    Moment().locale("es");
  },[])
  
  const getData = () => {
    getTSDPayment(sheetId);
  }

  if(loadingEconomicSheet) {
    return (
      <section className="container">
        <LoaderMin/>
      </section>
    )
  }

  if(errorEconomicSheet) {
    return (
      <section className="container">
        <p className="loader-text">Lo sentimos, se ha producido un error.</p>
      </section>
    )
  }

  return (
    <>
    {dataEconomicSheet===null?
    <section className="container">
      <p className="loader-text">No hay datos para mostrar.</p>
    </section>
    :
    <section className="container">
      <div className="col-xl-12 remarkable">
        <div className="row">
          <div className="col-xl-12">
            <h3 className="remarkable-title">{'Detalles'}</h3>
          </div>
          <div className="col-xl-3">
            <div className="item">
              <label className="item-label">{'Ejercicio'}</label>
              <input type="text" id="Ejercicio" className="item-value" value={dataEconomicSheet.exercise} readOnly={true}/>
            </div>
          </div>
          <div className="col-xl-3">
            <div className="item">
              <label className="item-label">{'Fecha Inicio Pago'}</label>
              <input type="text" id="FechaInicioPago" className="item-value" value={dataEconomicSheet.pay_start_date!==null?Moment(dataEconomicSheet.pay_start_date).format("DD/MM/YYYY"):""} readOnly={true}/>
            </div>
          </div>
          <div className="col-xl-3">
            <div className="item">
              <label className="item-label">{'Fecha Fin Pago'}</label>
              <input type="text" id="FechaFinPago" className="item-value" value={dataEconomicSheet.pay_end_date!==null?Moment(dataEconomicSheet.pay_end_date).format("DD/MM/YYYY"):""} readOnly={true}/>
            </div>
          </div>
          <div className="col-xl-3">
            <div className="item">
              <label className="item-label">{'Importe Pago'}</label>
              <input type="text" id="ImportePago" className="item-value" value={dataEconomicSheet.amount} readOnly={true}/>
            </div>
          </div>
          <div className="col-xl-3">
            <div className="item">
              <label className="item-label">{'Clase Pago'}</label>
              <input type="text" id="ClasePago" className="item-value" value={dataEconomicSheet.payment_class} readOnly={true}/>
            </div>
          </div>
          <div className="col-xl-3">
            <div className="item">
              <label className="item-label">{'Fecha Pago'}</label>
              <input type="text" id="FechaPago" className="item-value" value={dataEconomicSheet.pay_date!==null?Moment(dataEconomicSheet.pay_date).format("DD/MM/YYYY"):""} readOnly={true}/>
            </div>
          </div>
        </div>
      </div>

    </section>
    }
    </>
  )
}

export default TSDPago;